import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Optout() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const email = queryParams.get('_parm');

        if (email) {
            console.log('Unsubscribing user:', email);
            navigate('/UnsubscribeEmail', { state: { email } });
        } else {
            console.error('No email in the query string');
            navigate('/');
        }
    }, [location, navigate]);

    return (
        <div>
            <h1>Unsubscribe Email</h1>
            <p>You are about to unsubscribe from our newsletter.</p>
        </div>
    );
}

export default Optout;
